import Icon from 'Components/Icon';
import React from 'react';

export default props => <Icon icon={['fas', 'circle']} size={props.size || 'xs'} color={props.color} {...props}/>;
